/**
 * Benefits Arauris Section - Popup Functionality
 * Handles opening benefit detail popups when buttons are clicked
 */

class BenefitsAraurisPopup {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupEventListeners());
    } else {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    // Find all benefit popup buttons
    const benefitButtons = document.querySelectorAll('[data-benefit-popup]');

    benefitButtons.forEach(button => {
      button.addEventListener('click', (e) => this.handleButtonClick(e));
    });
  }

  handleButtonClick(event) {
    const button = event.currentTarget;
    const benefitName = button.getAttribute('data-benefit-name');
    const popupText = button.getAttribute('data-popup-text');

    // Find the section ID from the closest section
    const section = button.closest('section');
    if (!section) return;

    const sectionId = section.classList[1]; // Gets 'section-{id}' class
    const extractedId = sectionId ? sectionId.replace('section-', '') : '';

    // Find the popup component for this section
    const popupType = `benefit-popup-${extractedId}`;
    const popup = document.querySelector(`popup-component[popup-type="${popupType}"]`);
    if (!popup) {
      console.error('Popup component not found for section:', extractedId);
      return;
    }

    // Update popup content
    const titleElement = document.getElementById(`benefit-popup-title-${extractedId}`);
    const contentElement = document.getElementById(`benefit-popup-content-${extractedId}`);

    if (titleElement) {
      titleElement.textContent = benefitName || '';
    }

    if (contentElement) {
      // Handle richtext content - it's already escaped HTML from Liquid
      contentElement.innerHTML = popupText || '<p>No content available.</p>';
    }

    // Open the popup using the custom event system
    const showPopupEvent = new CustomEvent('action:showPopup', {
      bubbles: true,
      detail: {
        popupType: popupType
      }
    });
    document.dispatchEvent(showPopupEvent);
  }
}

// Initialize when script loads
new BenefitsAraurisPopup();
